import { Component, inject, input, OnDestroy, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { faClose, faEye } from '@fortawesome/pro-regular-svg-icons';

import { Subject, takeUntil } from 'rxjs';

import { MediaService } from '@eiq/files';
import { Media } from '@eiq/files/models';

import { FileType, FileTypeTexts, ImageTypes } from '@empathy/global/data';

import { StimulusPreviewDialogComponent } from '../stimulus-preview/stimulus-preview-dialog.component';

@Component({
  selector: 'empathy-shared-stimulus',
  templateUrl: 'stimulus.component.html',
  styleUrls: ['./stimulus.component.scss']
})
export class StimulusComponent implements OnDestroy {
  stimulus = input([], {
    transform: (value: Media[] | null) => {
      if (!value || Object.keys(value).length === 0) {
        return [];
      }
      return this.mapStimulusView(value);
    }
  });

  width = input(130);
  height = input(130);
  readonly = input(false);

  delete = output<number>();

  faEye = faEye;
  faClose = faClose;
  fileType = FileType;
  fileTypeTexts = FileTypeTexts;
  imageTypes = ImageTypes as string[];

  private mediaService = inject(MediaService);
  private dialog = inject(MatDialog);
  private destroyed$: Subject<boolean> = new Subject();

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  onPreview(media: Media): void {
    this.dialog.open(StimulusPreviewDialogComponent, {
      data: media
    });
  }

  private mapStimulusView(stimulus: Media[]): Media[] {
    stimulus
      .filter((s) => !s.url)
      .forEach((s) =>
        this.mediaService
          .getMediaUrl(s.mediaId)
          .pipe(takeUntil(this.destroyed$))
          .subscribe((media) => (s.url = media.url))
      );

    return stimulus;
  }
}
